import React from 'react';
import { makeStyles, Slide } from '@material-ui/core';

import { LYNKED_WHITE } from 'src/consts/colors';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    height: '150px',
    width: '100%',

    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom',
  },
  food_image: {
    background: 'rgba( 255, 255, 255, 0.50 )',

    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    color: LYNKED_WHITE,
    height: '100%',
    width: '100%',

    backdropFilter: 'blur( 10px )',
  },
  button: {
    color: LYNKED_WHITE,
    marginRight: '1rem',
  },
}));

export { useStyles, Transition };
